<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title
          class="title-name white--text"
          :style="dialogHeaderStyle"
        >{{ $t('select_dining_mode') }}</v-card-title>
        <v-divider />
        <v-container>
          <div
            v-for="(m, index) in modes"
            :key="index"
            @click="changeMode(m)"
          >
            <v-layout
              row
              align-center
              class="mode-card"
            >
              <v-flex
                xs3
                sm2
              >
                <v-icon
                  :size="icon(m).size"
                  :color="theme.btn_color_primary"
                  class="icon"
                >{{ icon(m).icon }}</v-icon>
              </v-flex>
              <v-flex
                xs9
                sm10
              >
                <span>{{ m.name }}</span>
              </v-flex>
            </v-layout>
            <v-divider v-if="index !== modes.length - 1" />
          </div>
          <div v-if="enableReservation">
            <v-divider />
            <v-layout
              row
              align-center
              class="mode-card"
              @click="goToReservationsTnc"
            >
              <v-flex
                xs3
                sm2
              >
                <v-icon
                  size="28px"
                  :color="theme.btn_color_primary"
                  class="icon"
                >fas fa-calendar-check</v-icon>
              </v-flex>
              <v-flex
                xs9
                sm10
              >
                <span>Make a Reservation</span>
              </v-flex>
            </v-layout>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'dining-mode-dialog',
  data: () => ({
    selectedTable: null,
  }),
  computed: {
    ...mapGetters('config', [
      'theme', 'iOS', 'inIframe', 'colors', 'modes', 'modeSelected', 'mode', 'enableReservation',
      'tbdata', 'tables',
    ]),
    ...mapGetters('area', [
      'selectedAreaMode'
    ]),
    dialog () {
      return (!this.modeSelected && this.modes.length > 1 && !this.selectedAreaMode)
    },
    dialogHeaderStyle () {
      return {
        backgroundColor: this.theme.btn_color_primary
      }
    }
  },
  methods: {
    icon (mode) {
      if (mode.isDinein) {
        return {
          icon: 'fas fa-utensils',
          size: '28px'
        }
      }
      if (mode.isTakeaway) {
        return {
          icon: 'fas fa-shopping-bag',
          size: '28px'
        }
      }
      if (mode.isDelivery) {
        return {
          icon: 'fas fa-truck',
          size: '25px'
        }
      }
    },
    changeMode (mode) {
      if (parseInt(mode.index) !== parseInt(this.mode.index)) {
        this.$store.dispatch('changeDiningMode', mode)
        this.$store.dispatch('config/setModeSelected')
        // this.$store.dispatch('fetchMode')
        this.$router.push({ name: 'welcome'})
      } else {
        this.$store.dispatch('config/setModeSelected')
        // this.$store.dispatch('fetchMode')
        this.$router.push({ name: 'welcome'})
      }
    },
    goToReservationsTnc () {
      this.$store.dispatch('config/setModeSelected')
      this.$router.push({ name: 'reservation_tnc' })
    }
  },
  mounted () {
    this.selectedTable = this.tbdata ? this.tbdata.Name : ''
    const table = this.tables.find(t => t.Name === this.selectedTable)
    if (this.selectedAreaMode || table) {
      let temp = ''
      if (this.selectedAreaMode && this.selectedAreaMode.isDinein) temp = 'isDinein'
      if (this.selectedAreaMode && this.selectedAreaMode.isTakeaway) temp = 'isTakeaway'
      if (this.selectedAreaMode && this.selectedAreaMode.isDelivery) temp = 'isDelivery'
      if (table) {
        temp = 'isDinein'
        this.$store.dispatch('config/setModeSelected')
      }
      if (temp !== '') {
        this.modes.forEach((m) => {
          if (m[temp]) {
            this.$store.dispatch('config/changeMode', m)
            this.$store.dispatch('fetchMenuCats')
            if (temp !== 'isDelivery') this.$store.dispatch('dialog/hideSettingDialog')
          }
        })
      }
      this.$store.dispatch('area/resetSelectedArea')
    }
  }
}
</script>

<style scoped>
.title-name {
  font-size: 17px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.icon {
  padding: 8px;
}
.mode-card {
  cursor: pointer;
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/DiningModeDialog.vue